const CREATED_PREFIX = 'booking:createdReservation:';

const positiveId = value => {
  const text = String(value ?? '').trim();
  return /^[1-9]\d*$/.test(text) && Number.isSafeInteger(Number(text)) ? text : null;
};

// Navigation evidence only. Never store a vendor session, passengers or payment data.
export function rememberCreatedBooking(scheduleId, result, storage = window.sessionStorage) {
  const reservationIdx = positiveId(result?.reservation_idx);
  if (scheduleId == null || result?.success !== true || !reservationIdx) return false;
  try {
    const value = JSON.stringify({ version: 1, reservationIdx });
    const key = `${CREATED_PREFIX}${scheduleId}`;
    storage.setItem(key, value);
    return storage.getItem(key) === value;
  } catch (_) {
    return false;
  }
}

// Evaluate once on entering this route, before any reservation input component mounts.
// A fresh visit from the detail page has no step state and may start another booking.
export function getCreatedBookingEntry(scheduleId, historyState, storage = window.sessionStorage) {
  if (scheduleId == null) return null;
  try {
    const snapshotText = storage.getItem(`booking:snapshot:${scheduleId}`);
    let snapshot = null;
    try { snapshot = snapshotText ? JSON.parse(snapshotText) : null; } catch (_) { /* independent marker may still identify the booking */ }
    const markerText = storage.getItem(`${CREATED_PREFIX}${scheduleId}`);
    let marker = null;
    try { marker = markerText ? JSON.parse(markerText) : null; } catch (_) { /* legacy snapshot still applies */ }
    const reservationIdx = positiveId(snapshot?.createdReservationIdx)
      || (marker?.version === 1 ? positiveId(marker.reservationIdx) : null);
    const legacyCreated = snapshot?.reservationCreated === true;
    const hasHistoryStep = Number.isInteger(historyState?.step) && historyState.step >= 0 && historyState.step <= 5;
    const cruiseId = storage.getItem(`booking:scheduleToCruiseId:${scheduleId}`);
    const hasScopedSession = Boolean(storage.getItem(`booking:sessionKey:${scheduleId}`)
      || (cruiseId && storage.getItem(`booking:sessionKey:${cruiseId}`)));
    if (!legacyCreated && !(reservationIdx && hasHistoryStep && !hasScopedSession)) return null;
    return {
      path: reservationIdx ? `/mypage/reservation-complete/detail?idx=${reservationIdx}` : '/mypage',
      legacyCreated,
    };
  } catch (_) {
    return null;
  }
}
